import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { QcDefect } from './qc-defect-entity';
import { QcDefectController } from './qc-defect.controller';
import { QcDefectService } from './qc-defect.service';
import { QcDefectAdapter } from './dto/qc-defect-adapter';
import { QcdefectitemEntity } from './dto/qc-defect-items-entity';
@Module({

    imports:[TypeOrmModule.forFeature([QcDefect,QcdefectitemEntity]),

],
controllers:[QcDefectController],
providers:[QcDefectService,QcDefectAdapter,ApplicationExceptionHandler],
exports:[],

})
export class QcDefectModule{}